import { render, staticRenderFns } from "./IN.vue?vue&type=template&id=1cd25385&scoped=true"
import script from "./IN.vue?vue&type=script&lang=js"
export * from "./IN.vue?vue&type=script&lang=js"
import style0 from "./IN.vue?vue&type=style&index=0&id=1cd25385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd25385",
  null
  
)

export default component.exports